export default () => (
  window.availableLocales.flatMap(({ active, code, name }) => (
    active ? { label: name, value: code } : []
  ))
);
